module.exports = __webpack_public_path__ + "bb68d79cb8d6a880df31a5f452d4c9a7.svg";